// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"b9a8d6d4","92":"cb5f000a","138":"234ee3db","274":"0535d21a","431":"faaa2da7","488":"8de253b7","634":"3a6dcdc4","893":"b5dac343","968":"a9fc2ab6"}[chunkId] + ".chunk.js";
};